// TODO: resolve CHCP disables by bot
// eslint-disable-next-line max-classes-per-file
import { Action } from '@ngrx/store';

import {
  PatientSearchObject,
  SearchInfoResponse,
  InactivePatientSearchObject,
  PharmacyResponse,
  PharmacyFacetRequest,
  PatientDetailRequest,
  SureFitRequest,
  PrecertData,
  CoverageDetail,
  PatientDetailsObj,
  BRNPayload,
  Alliance,
  IdCardDetails,
  ProviderDetailsRequest,
  AmInNetworkStatus,
  PatientResultObject,
} from '@cigna/chcp/patient/shared/util';

import { ServiceError } from '@cigna/chcp/shared/util';

import {
  ProviderNetworkVerificationRequest,
  PathwellNetworkVerificationRequest,
  FnsNetworkVerificationRequest,
} from '@cigna/chcp/shared/provider-data-access';

export enum PatientActionTypes {
  ResetSearch = '[PatientSearch] Reset Search',
  NewSearch = '[PatientSearch] New Search',
  ModifySearch = '[PatientSearch] Modify Search',
  SearchPatients = '[PatientSearch] Search Patients',
  SearchPatientsError = '[PatientSearch] Search Patients Error',
  SearchPatientsSuccess = '[PatientSearch] Search Patients Success',
  ChangeResultFilter = '[PatientResults] Change Result Filter',
  InactiveMemberSearch = '[PatientSearch] Inactive Member Search',
  InactiveMemberSearchSuccess = '[PatientSearch] Inactive Member Search Success',
  InactiveMemberSearchError = '[PatientSearch] Inactive Member Search Error',
  GetPatientDetail = '[PatientDetails] Get Patient Detail',
  GetPatientDetailSuccess = '[PatientDetails] Get Patient Detail Success',
  GetPatientDetailError = '[PatientDetails] Get Patient Detail Error',
  GetAmInNetworkStatus = '[PatientDetails] Get Am I In Network Status',
  GetProviderGroup = '[PatientDetails] Get Provider Group',
  GetProviderGroupSuccess = '[PatientDetails] Get Provider Group Success',
  GetProviderGroupError = '[PatientDetails] Get Provider Group Error',
  GetProviders = '[PatientDetails] Get Providers',
  GetProvidersSuccess = '[PatientDetails] Get Providers Success',
  GetProvidersError = '[PatientDetails] Get Providers Error',
  GetProviderDetails = '[PatientDetails] Get Provider Details',
  GetProviderDetailsSuccess = '[PatientDetails] Get Provider Details Success',
  GetProviderDetailsError = '[PatientDetails] Get Provider Details Error',
  GetInOutNetworkDetails = '[PatientDetails] Get In Out Network Details',
  GetInOutNetworkDetailsSuccess = '[PatientDetails] Get In Out Network Details Success',
  GetInOutNetworkDetailsError = '[PatientDetails] Get Pathwell In Out Network Details Error',
  GetPathwellIFPInOutNetworkDetails = '[PatientDetails] Get Pathwell In Out Network Details',
  GetPathwellInOutNetworkDetailsError = '[PatientDetails] Get In Out Network Details Error',
  GetFNSInOutNetworkDetails = '[PatientDetails] Get FNS In Out Network Details',
  ResetProviderData = '[PatientDetails] Reset Provider Data',
  GetPharmacyFacets = '[PatientDetails] Get Pharmacy Facets',
  GetPharmacyFacetsSuccess = '[PatientDetails] Get Pharmacy Facets Success',
  GetPharmacyFacetsError = '[PatientDetails] Get Pharmacy Facets Error',
  ResetErrors = '[PatientDetails] Reset Errors',
  UpdateCompositeKey = '[PatientDetails] Update Composite Key',
  GetCostEstimatorDetail = '[PatientDetails] Get Patient Cost of Care Estimation Detail',
  GetCostEstimatorDetailSuccess = '[PatientDetails] Get Patient Cost of Care Estimation Detail Success',
  GetCostEstimatorDetailError = '[PatientDetails] Get Patient Cost of Care Estimation Detail Error',
  GetServiceProcedures = '[PatientDetails] Get Patient Service Procedures',
  GetServiceProceduresSuccess = '[PatientDetails] Get Patient Service Procedures Success',
  GetServiceProceduresError = '[PatientDetails] Get Patient Service Procedures Error',
  ResetServiceProcedures = '[PatientDetails] Reset Patient Service Procedures',
  SetEstimateType = '[PatientDetails] Set Patient Estimate Type',
  PatientEstimateCost = '[PatientDetails] Get Patient Estimate Cost',
  ResetPatientEstimateCost = '[PatientDetails] Get Patient Estimate Cost',
  PatientEstimateCostSuccess = '[PatientDetails] Get Patient Estimate Cost Success',
  PatientEstimateCostError = '[PatientDetails] Get Patient Estimate Cost Error',
  ResetSubmitEstimateError = '[PatientDetails] Reset Patient Estimate Cost Error',
  OpenAccordionDetails = '[PatientDetails] Get Opened Accordion Details',
  GetSureFitDetails = '[PatientDetails] Surefit Details',
  SureFitSuccess = '[PatientDetails] SureFit Directory Success',
  SureFitError = '[PatientDetails] SureFit Directory Error',
  SetOhpTin = '[PatientDetails] Set Selected Ohp Tin',
  GetPrecertUrl = '[PatientDetails] Get Precertification Url',
  GetPrecertUrlSuccess = '[PatientDetails] Get Precertification Url Success',
  GetPrecertUrlError = '[PatientDetails] Get Precertification Url Error',
  HydratePatientDataFromCoverages = '[PatientDetails] Hydrate Patient Data From Coverages',
  HydrateServiceAccumFromCoverages = '[PatientDetails] Hydrate Service Accumulation Data From Coverages',
  HydrateIdCardFromCoverages = '[PatientDetails] Hydrate Id card Data From Coverages',
  ResetDetails = '[PatientDetails] Reset patient details',
}

export class ResetSearch implements Action {
  readonly type = PatientActionTypes.ResetSearch;
}
export class ResetDetails implements Action {
  readonly type = PatientActionTypes.ResetDetails;
}

export class ModifySearch implements Action {
  readonly type = PatientActionTypes.ModifySearch;
}

export class NewSearch implements Action {
  readonly type = PatientActionTypes.NewSearch;
}

export class SearchPatients implements Action {
  readonly type = PatientActionTypes.SearchPatients;
  constructor(public payload: PatientSearchObject) {}
}

export class SearchPatientsError implements Action {
  readonly type = PatientActionTypes.SearchPatientsError;
  constructor(public error: ServiceError) {}
}

export class SearchPatientsSuccess implements Action {
  readonly type = PatientActionTypes.SearchPatientsSuccess;
  constructor(
    public payload: {
      patients: PatientResultObject[];
      searchInfo: SearchInfoResponse;
    },
  ) {}
}

export class InactiveMemberSearch implements Action {
  readonly type = PatientActionTypes.InactiveMemberSearch;
  constructor(public payload: InactivePatientSearchObject) {}
}

export class InactiveMemberSearchSuccess implements Action {
  readonly type = PatientActionTypes.InactiveMemberSearchSuccess;
  constructor(
    public payload: {
      display: any;
      detail: any;
      uniqueIdentifier: number;
    },
  ) {}
}

export class InactiveMemberSearchError implements Action {
  readonly type = PatientActionTypes.InactiveMemberSearchError;
  constructor(public payload: string) {}
}

export class ChangeResultFilter implements Action {
  readonly type = PatientActionTypes.ChangeResultFilter;
  constructor(public payload: string) {}
}

export class GetPatientDetail implements Action {
  readonly type = PatientActionTypes.GetPatientDetail;
  constructor(public data: PatientDetailRequest) {}
}

export class GetPatientDetailSuccess implements Action {
  readonly type = PatientActionTypes.GetPatientDetailSuccess;
  constructor(public data: any, public compositeKey?: string) {}
}

export class GetPatientDetailError implements Action {
  readonly type = PatientActionTypes.GetPatientDetailError;
  constructor(public error: ServiceError) {}
}

export class GetPharmacyFacets implements Action {
  readonly type = PatientActionTypes.GetPharmacyFacets;
  constructor(public payload: PharmacyFacetRequest) {}
}

export class GetPharmacyFacetsSuccess implements Action {
  readonly type = PatientActionTypes.GetPharmacyFacetsSuccess;
  constructor(public pharmacyResponse: PharmacyResponse) {}
}

export class GetPharmacyFacetsError implements Action {
  readonly type = PatientActionTypes.GetPharmacyFacetsError;
  constructor(public error: any) {}
}

export class GetAmInNetworkStatus implements Action {
  readonly type = PatientActionTypes.GetAmInNetworkStatus;
  constructor(public payload: AmInNetworkStatus) {}
}

export class GetProviderGroup implements Action {
  readonly type = PatientActionTypes.GetProviderGroup;
  constructor(public payload: string) {}
}
export class GetProviderGroupSuccess implements Action {
  readonly type = PatientActionTypes.GetProviderGroupSuccess;
  constructor(public payload: any) {}
}
export class GetProviderGroupError implements Action {
  readonly type = PatientActionTypes.GetProviderGroupError;
  constructor(public error: any) {}
}

export class GetProviders implements Action {
  readonly type = PatientActionTypes.GetProviders;
  constructor(public payload: string[]) {}
}
export class GetProvidersSuccess implements Action {
  readonly type = PatientActionTypes.GetProvidersSuccess;
  constructor(public payload: any) {}
}
export class GetProvidersError implements Action {
  readonly type = PatientActionTypes.GetProvidersError;
  constructor(public error: any) {}
}

export class GetProviderDetails implements Action {
  readonly type = PatientActionTypes.GetProviderDetails;
  constructor(public payload: ProviderDetailsRequest) {}
}
export class GetProviderDetailsSuccess implements Action {
  readonly type = PatientActionTypes.GetProviderDetailsSuccess;
  constructor(public payload: any) {}
}
export class GetProviderDetailsError implements Action {
  readonly type = PatientActionTypes.GetProviderDetailsError;
  constructor(public error: any) {}
}

export class GetInOutNetworkDetails implements Action {
  readonly type = PatientActionTypes.GetInOutNetworkDetails;
  constructor(
    public data: {
      payload: ProviderNetworkVerificationRequest;
      isIndemnity: boolean;
    },
  ) {}
}
export class GetInOutNetworkDetailsSuccess implements Action {
  readonly type = PatientActionTypes.GetInOutNetworkDetailsSuccess;
  constructor(public payload: any) {}
}
export class GetInOutNetworkDetailsError implements Action {
  readonly type = PatientActionTypes.GetInOutNetworkDetailsError;
  constructor(public error: any) {}
}

export class GetPathwellIFPInOutNetworkDetails implements Action {
  readonly type = PatientActionTypes.GetPathwellIFPInOutNetworkDetails;
  constructor(
    public data: {
      payload: PathwellNetworkVerificationRequest;
      isIndemnity: boolean;
      hasIFP: boolean;
    },
  ) {}
}
export class GetFNSInOutNetworkDetails implements Action {
  readonly type = PatientActionTypes.GetFNSInOutNetworkDetails;
  constructor(
    public data: {
      payload: FnsNetworkVerificationRequest;
      isIndemnity: boolean;
    },
  ) {}
}

export class ResetProviderData implements Action {
  readonly type = PatientActionTypes.ResetProviderData;
  constructor(public key: string) {}
}
export class ResetErrors implements Action {
  readonly type = PatientActionTypes.ResetErrors;
}
export class UpdateCompositeKey implements Action {
  readonly type = PatientActionTypes.UpdateCompositeKey;
  constructor(public key: string) {}
}
export class OpenAccordionDetails implements Action {
  readonly type = PatientActionTypes.OpenAccordionDetails;
  constructor(public key: string) {}
}
export class SetEstimateType implements Action {
  readonly type = PatientActionTypes.SetEstimateType;
  constructor(public estimateType: string) {}
}
export class GetCostEstimatorDetail implements Action {
  readonly type = PatientActionTypes.GetCostEstimatorDetail;
  constructor(
    public key: string,
    public patientType: string,
    public network: string,
  ) {}
}

export class GetCostEstimatorDetailSuccess implements Action {
  readonly type = PatientActionTypes.GetCostEstimatorDetailSuccess;
  constructor(public data: any, public key: string) {}
}

export class GetCostEstimatorDetailError implements Action {
  readonly type = PatientActionTypes.GetCostEstimatorDetailError;
  constructor(public error: any) {}
}

export class PatientEstimateCost implements Action {
  readonly type = PatientActionTypes.PatientEstimateCost;
  constructor(public payload: any) {}
}

export class PatientEstimateCostSuccess implements Action {
  readonly type = PatientActionTypes.PatientEstimateCostSuccess;
  constructor(public data: any, public payload: any) {}
}

export class ResetPatientEstimateCost implements Action {
  readonly type = PatientActionTypes.ResetPatientEstimateCost;
}

export class PatientEstimateCostError implements Action {
  readonly type = PatientActionTypes.PatientEstimateCostError;
  constructor(public error: ServiceError) {}
}

export class ResetSubmitEstimateError implements Action {
  readonly type = PatientActionTypes.ResetSubmitEstimateError;
}

export class GetServiceProcedures implements Action {
  readonly type = PatientActionTypes.GetServiceProcedures;
  constructor(public payload: any) {}
}

export class GetServiceProceduresSuccess implements Action {
  readonly type = PatientActionTypes.GetServiceProceduresSuccess;
  constructor(public data: any, public payload: any) {}
}

export class GetServiceProceduresError implements Action {
  readonly type = PatientActionTypes.GetServiceProceduresError;
  constructor(public error: any) {}
}

export class ResetServiceProcedures implements Action {
  readonly type = PatientActionTypes.ResetServiceProcedures;
}
export class GetSureFitDetails implements Action {
  readonly type = PatientActionTypes.GetSureFitDetails;
  constructor(public payload: SureFitRequest) {}
}

export class SureFitSuccess implements Action {
  readonly type = PatientActionTypes.SureFitSuccess;
  constructor(public payload: any) {}
}

export class SureFitError implements Action {
  readonly type = PatientActionTypes.SureFitError;
  constructor(public error: any) {}
}

export class SetOhpTin implements Action {
  readonly type = PatientActionTypes.SetOhpTin;
  constructor(public ohpTin: any) {}
}

export class GetPrecertUrl implements Action {
  readonly type = PatientActionTypes.GetPrecertUrl;
}

export class GetPrecertUrlSuccess implements Action {
  readonly type = PatientActionTypes.GetPrecertUrlSuccess;
  constructor(public data: PrecertData) {}
}

export class GetPrecertUrlError implements Action {
  readonly type = PatientActionTypes.GetPrecertUrlError;
  constructor(public error: any) {}
}

export class HydratePatientDataFromCoverages implements Action {
  readonly type = PatientActionTypes.HydratePatientDataFromCoverages;
  constructor(
    public payload: {
      patient: PatientDetailsObj;
      coverage: CoverageDetail;
      alliance: Alliance;
      compositeKey: string;
      reference?: BRNPayload;
    },
  ) {}
}
export class HydrateIdCardFromCoverages implements Action {
  readonly type = PatientActionTypes.HydrateIdCardFromCoverages;
  constructor(
    public payload: {
      idCardDetails: IdCardDetails | null;
      error: ServiceError | null;
    },
  ) {}
}

export type PatientActions =
  | ResetSearch
  | NewSearch
  | ModifySearch
  | SearchPatients
  | SearchPatientsError
  | SearchPatientsSuccess
  | InactiveMemberSearch
  | InactiveMemberSearchError
  | InactiveMemberSearchSuccess
  | ChangeResultFilter
  | GetPatientDetail
  | GetPatientDetailSuccess
  | GetPatientDetailError
  | GetAmInNetworkStatus
  | GetProviderGroup
  | GetProviderGroupSuccess
  | GetProviderGroupError
  | GetProviders
  | GetProvidersSuccess
  | GetProvidersError
  | GetProviderDetails
  | GetProviderDetailsSuccess
  | GetProviderDetailsError
  | GetInOutNetworkDetails
  | GetInOutNetworkDetailsSuccess
  | GetInOutNetworkDetailsError
  | GetPathwellIFPInOutNetworkDetails
  | GetFNSInOutNetworkDetails
  | GetPharmacyFacets
  | GetPharmacyFacetsSuccess
  | GetPharmacyFacetsError
  | ResetProviderData
  | ResetErrors
  | UpdateCompositeKey
  | SetEstimateType
  | GetCostEstimatorDetail
  | GetCostEstimatorDetailSuccess
  | GetCostEstimatorDetailError
  | GetServiceProcedures
  | GetServiceProceduresSuccess
  | GetServiceProceduresError
  | ResetServiceProcedures
  | PatientEstimateCost
  | PatientEstimateCostSuccess
  | PatientEstimateCostError
  | ResetSubmitEstimateError
  | OpenAccordionDetails
  | GetSureFitDetails
  | SureFitSuccess
  | SureFitError
  | SetOhpTin
  | GetPrecertUrl
  | GetPrecertUrlSuccess
  | GetPrecertUrlError
  | HydratePatientDataFromCoverages
  | HydrateIdCardFromCoverages
  | ResetDetails;
